export default __webpack_public_path__ + "static/fp-logo-1718642c30379303304fdbf4e9ef1878.png";